@if (requestId(); as requestId) {
  <cxp-new-crl-page [hostedRequestId]="requestId" [showBreadcrumb]="false" />
}
